import { render, staticRenderFns } from "./VerTodosPedidos.vue?vue&type=template&id=1b21fe80&scoped=true"
import script from "./VerTodosPedidos.vue?vue&type=script&lang=js"
export * from "./VerTodosPedidos.vue?vue&type=script&lang=js"
import style0 from "./VerTodosPedidos.vue?vue&type=style&index=0&id=1b21fe80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b21fe80",
  null
  
)

export default component.exports